'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _f3tch = require('f3tch');

var _f3tch2 = _interopRequireDefault(_f3tch);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$driverID = _ref.driverID,
      driverID = _ref$driverID === undefined ? null : _ref$driverID,
      _ref$rentalID = _ref.rentalID,
      rentalID = _ref$rentalID === undefined ? null : _ref$rentalID,
      _ref$version = _ref.version,
      version = _ref$version === undefined ? '0.0.0' : _ref$version;

  return (0, _f3tch2.default)('/docs/contract/' + driverID + '/' + rentalID + '/' + version + '/').profile('html').get();
};